import React from 'react';
import PropTypes from 'prop-types';

import { SuiModal, SuiSpinner } from '@splashthat/sui';

const Modal = ({ children, loading, open, onRequestClose }) => (
    <SuiModal
        size="thin"
        overlay="dark"
        open={open}
        onRequestClose={loading ? undefined : onRequestClose}
        showCloseButton={false}
        closeOnClickOutside={!!loading}
    >
        {loading ? <SuiSpinner /> : children}
    </SuiModal>
);

Modal.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    open: PropTypes.bool,
    loading: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
};

Modal.defaultProps = {
    open: false,
    loading: false,
};

export default Modal;
